import React, { useState } from 'react';
import { useFetch } from '../../hooks/useFetch';
import { showGlobalToast, Spinner, ErrorBanner, EmptyState } from '../../components/ui';
import { useAuth } from '../../context/AuthContext';
import api from '../../utils/api';
import AddVendorModal from './AddVendor';
import EditVendorModal from './EditVendor';
import VendorDiscountsModal from './VendorDiscounts';

export default function Vendors() {
  const { data, loading, error, refetch } = useFetch('/api/vendors');
  const { isManager } = useAuth();
  const [search, setSearch] = useState('');
  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(null);
  const [discountModal, setDiscountModal] = useState(null);

  const filtered = (data || []).filter(v => !search || v.name.toLowerCase().includes(search.toLowerCase()));

  const deleteVendor = async (v) => {
    if (!window.confirm(`Delete vendor "${v.name}"? This cannot be undone.`)) return;
    try { await api.delete(`/api/vendors/${v.id}`); refetch(); showGlobalToast('Vendor deleted'); }
    catch(err) { alert(err.response?.data?.error || err.message); }
  };

  if (loading) return <Spinner />;
  if (error) return <ErrorBanner message={error} onRetry={refetch} />;

  return (
    <div>
      <div className="page-header">
        <h1>Vendors</h1>
        <div className="page-actions">
          <button className="btn btn-primary btn-sm" onClick={() => setAddModal(true)}>
            <i className="ti ti-plus" /> Add vendor
          </button>
        </div>
      </div>

      {addModal && <AddVendorModal onClose={() => setAddModal(false)} onSaved={(msg) => { refetch(); showGlobalToast(msg || 'Saved'); }} />}
      {discountModal && <VendorDiscountsModal vendor={discountModal} onClose={() => setDiscountModal(null)} />}
      {editModal && <EditVendorModal vendor={editModal} onClose={() => setEditModal(null)} onSaved={(msg) => { refetch(); showGlobalToast(msg || 'Saved'); setEditModal(null); }} />}

      <div className="filter-bar">
        <div className="search-input"><i className="ti ti-search" /><input placeholder="Search vendors…" value={search} onChange={e => setSearch(e.target.value)} /></div>
      </div>

      <div className="card">
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                {isManager && <th style={{ width:40 }}></th>}
                <th>Name</th>
                <th>Contact</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Address</th>
                <th>Materials</th>
                <th>POs</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map(v => (
                <tr key={v.id}>
                  {isManager && (
                    <td style={{ whiteSpace:'nowrap' }}>
                      <button className="btn btn-sm" onClick={() => setEditModal(v)} title="Edit" style={{ marginRight:4 }}>
                        <i className="ti ti-pencil" />
                      </button>
                      <button className="btn btn-sm" onClick={() => setDiscountModal(v)} title="Quantity discounts" style={{ marginRight:4 }}>
                        <i className="ti ti-discount" />
                      </button>
                      <button className="btn btn-sm btn-danger" onClick={() => deleteVendor(v)} title="Delete">
                        <i className="ti ti-trash" />
                      </button>
                    </td>
                  )}
                  <td style={{ fontWeight:500 }}>{v.name}</td>
                  <td>{v.contact_name || '—'}</td>
                  <td style={{ fontSize:12 }}>{v.email || '—'}</td>
                  <td style={{ fontSize:12 }}>{v.phone || '—'}</td>
                  <td style={{ fontSize:12, maxWidth:180, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>{v.address || '—'}</td>
                  <td>{v.material_count}</td>
                  <td>{v.po_count}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {!filtered.length && <EmptyState icon="ti-truck" message="No vendors found" />}
        </div>
      </div>
    </div>
  );
}
